import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel, Btn, Badge, Th, Td, Field, Input } from "@/admin/ui";

export default function Users() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const load = () => api.get("/api/admin/users").then((r) => setItems(r.data.items || []));
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const create = async () => {
    try { await api.post("/api/admin/users", { ...form, role: "admin" }); toast.success("Admin created"); setForm({ name: "", email: "", password: "" }); await load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const disable = async (u) => {
    try { await api.delete(`/api/admin/users/${u.id}`); toast.success("User disabled"); await load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div data-testid="admin-users">
      <h1 className="mb-6 text-2xl font-bold text-ink-heading">Admin Users</h1>
      <div className="grid gap-4 lg:grid-cols-3">
        <Panel title="Add administrator" testid="user-create">
          <div className="space-y-4">
            <Field label="Name"><Input value={form.name} onChange={set("name")} data-testid="user-name" /></Field>
            <Field label="Email"><Input type="email" value={form.email} onChange={set("email")} data-testid="user-email" /></Field>
            <Field label="Temporary password"><Input type="text" value={form.password} onChange={set("password")} data-testid="user-password" /></Field>
            <Btn onClick={create} data-testid="user-add">Create account</Btn>
            <p className="text-xs text-ink-muted">New admins set up MFA on first sign-in.</p>
          </div>
        </Panel>
        <div className="lg:col-span-2">
          <Panel title="Accounts">
            <table className="w-full">
              <thead className="border-b border-slate-100"><tr><Th>Name</Th><Th>Email</Th><Th>MFA</Th><Th>Status</Th><Th></Th></tr></thead>
              <tbody className="divide-y divide-slate-50">
                {items.map((u) => (
                  <tr key={u.id} data-testid={`user-row-${u.email}`}>
                    <Td className="font-medium text-ink-heading">{u.name}</Td>
                    <Td>{u.email}</Td>
                    <Td>{u.mfa_enabled ? <Badge status="active" /> : <span className="text-xs text-ink-muted">not set</span>}</Td>
                    <Td>{u.disabled ? <span className="text-xs text-red-600">disabled</span> : <Badge status="active" />}</Td>
                    <Td>{u.id !== user?.id && !u.disabled ? <Btn variant="danger" onClick={() => disable(u)} data-testid={`user-disable-${u.email}`}>Disable</Btn> : <span className="text-xs text-ink-muted">—</span>}</Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Panel>
        </div>
      </div>
    </div>
  );
}
